var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgText = function SvgText(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 40,
    fill: "inherit"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8672_15837)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M29.611 18.867h-6.533a.94.94 0 0 0-.933.933v1.312a.94.94 0 0 0 .933.933.94.94 0 0 0 .933-.933v-.378h1.4v5.322H24.39a.94.94 0 0 0-.933.933c0 .511.422.934.933.934h3.922a.94.94 0 0 0 .933-.934.94.94 0 0 0-.933-.933H27.29v-5.322h1.4v.378c0 .51.422.933.933.933a.94.94 0 0 0 .934-.933V19.8a.94.94 0 0 0-.934-.934z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M21.722 26.056h-2.389V12.978h5.6v.722c0 .511.423.934.934.934a.94.94 0 0 0 .933-.934v-1.655a.94.94 0 0 0-.933-.934H10.933a.94.94 0 0 0-.933.934V13.7c0 .511.422.934.933.934a.94.94 0 0 0 .934-.934v-.722h5.6v13.078h-2.39a.94.94 0 0 0-.933.933c0 .511.423.933.934.933h6.644a.94.94 0 0 0 .934-.933.94.94 0 0 0-.934-.933"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8672_15837"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 11.111h20.544v16.811H10z"
  })))));
};
export default SvgText;